export enum ProvideInjectConsts {
  RegisterCheckoutCallback = "registerCheckoutCallback",
  UnRegisterCheckoutCallback = "unregisterCheckoutCallback",
  ShowErrorSnackBar = "showErrorSnackBar",
}
